import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

const setup_chart = () => {
  ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

  // Set global defaults
  ChartJS.defaults.plugins.legend.display = false
  ChartJS.defaults.plugins.title.display = false
}

export const chart_options = {
  responsive: true,
  maintain_aspect_ratio: false,
  plugins: {
    legend: {
      display: false
    },
    title: {
      display: false
    }
  }
}

export default setup_chart
